<template>
  <div class="conference">
    <div class="conference-body">
      <vue-jitsi-meet
        ref="jitsiRef"
        domain="meet.jit.si"
        :options="jitsiOptions"
      ></vue-jitsi-meet>
    </div>
  </div>
</template>

<script>
import { cardUpdateResource, cardContentResource } from "@/plugins/functions";

import { mapState } from "vuex";
export default {
  data: () => ({}),

  props: ["id", "close"],

  methods: {
    onIFrameLoad() {
      // this.$refs.jitsiRef.addEventListener("readyToClose", this.readyToClose);
    },
  },

  destroyed() {},
  computed: {
    ...mapState(["user"]),
    jitsiOptions() {
      return {
        roomName: `sbi-ticket-${this.id}`,
        noSSL: false,
        userInfo: {
          email: this.$store.state.user.email
            ? this.$store.state.user.email
            : "no-email",
          displayName: this.$store.state.user.name,
        },
        configOverwrite: {
          enableNoisyMicDetection: false,
          defaultLanguage: "ru",
        },
        interfaceConfigOverwrite: {
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_CHROME_EXTENSION_BANNER: false,
          SHOW_PROMOTIONAL_CLOSE_PAGE: false,
          DEFAULT_LOCAL_DISPLAY_NAME: this.$store.state.user.name,
          TOOLBAR_BUTTONS: [
            "camera",
            // {
            //   key: "chat",
            //   preventExecution: false,
            // },
            // {
            //   key: "closedcaptions",
            //   preventExecution: true,
            // },
            "desktop",
            // "download",
            // "embedmeeting",
            // "etherpad",
            // "feedback",
            // "filmstrip",
            // "fullscreen",
            // "hangup",
            // "help",
            // {
            //   key: "invite",
            //   preventExecution: false,
            // },
            // "livestreaming",
            "microphone",
            // "mute-everyone",
            // "mute-video-everyone",
            // "participants-pane",
            // "profile",
            // {
            //   key: "raisehand",
            //   preventExecution: true,
            // },
            // "recording",
            // "security",
            // "select-background",
            // "settings",
            // "shareaudio",
            // "sharedvideo",
            // "shortcuts",
            // "stats",
            // "tileview",
            // "toggle-camera",
            // "videoquality",
            // // The add passcode button from the security dialog.
            // {
            //   key: "add-passcode",
            //   preventExecution: false,
            // },
            // "__end",
          ],
        },
        onload: this.onIFrameLoad,
      };
    },
  },
};
</script>
<style lang="scss">
.conference {
  position: relative;
  &-body {
    width: 100%;
    height: calc(100vh - 360px);
    background: #222;

    oveflow: hidden;
  }
}
</style>
